<template>
  <div class="BindPhone">
    <el-dialog :title="$t('components.text20')" v-model="BindingEmailModelFlagNext" width='400px'
      custom-class="modify_the_email" :close-on-click-modal="false" destroy-on-close @closed="beforeClose">
      <PhoneInputBox :blurFunc="phoneBlur" @mobileAreaCodeChange="mobileAreaCodeChange" :disabled="false" :value="phoneData.phone" :code="phoneData.mobileAreaCode" />
      <CodeInputBox :blurFunc="codeBlur" :mobileAreaCode="phoneData.mobileAreaCode" :phone="phoneData.phone"
        :value="phoneData.code" :smsType='phoneData.smsType' :placeholder="$t('components.text14')" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="BindingEmailModelFlagNext = false">{{ $t('trade.text72') }}</el-button>
          <el-button type="primary" :loading='loading' :disabled="!submitFlag"
            @click="bindPhone">{{ $t('myAccount.text22') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="$t('components.text20')" v-model="BindingEmailModelFlag" width='400px'
      custom-class="modify_the_email_2" :close-on-click-modal="false" @closed="beforeClose">
      <div class="phone-con input-row">
        <div class="value"><input type="email" disabled v-model="emailData.email" :placeholder="$t('components.text16')" /></div>
      </div>
      <div class="code-input input-row">
        <div class="value">
          <input class="value_code" v-model="emailData.code" type="text" :placeholder="$t('components.text17')" />
        </div>
        <el-button class="send" link @click="sendEmailCode">{{ sendMessage }}</el-button>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="BindingEmailModelFlag = false">{{ $t('trade.text72') }}</el-button>
          <el-button type="primary" :loading='loading' :disabled="!emailSubmitFlag"
            @click="sureEmailOK">{{ $t('components.text15') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  inject, ref, reactive, computed, onBeforeUnmount
} from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";

export default {
  name: 'BindPhone',
  setup() {
    const store = useStore();
    const emitt = inject('emitt');
    const { t } = useI18n()

    // 手机验证弹框出现/消失
    const BindingEmailModelFlagNext = ref(false);
    // 邮箱验证弹框出现/消失
    const BindingEmailModelFlag = ref(false);
    //发送手机验证码按钮文本
    const sendMessage = ref(t('signUp.text16'))
    //
    const loading = ref(false)
    const lang = computed({ get: () => store.getters.getNowTheme.lang });


    function codeBlur(val) {
      phoneData.code = val;
    }
    function phoneBlur(val) {
      phoneData.phone = val;
    }

    function mobileAreaCodeChange(e){
      phoneData.mobileAreaCode = e;
    }
    /**
     * 打开弹框-开始
     */
    emitt.$sub('openBindingPhoneModel', (val) => {
      BindingEmailModelFlag.value = true;
      const { email } = val[0];
      emailData.email = email;
    });
    onBeforeUnmount(() => {
      emitt.$unsub("openBindingPhoneModel");
    });
    /**
     * 打开弹框-开始
     */

    /**
     * 电话验证参数-开始
     */
    const phoneData = reactive({
      phone: "",//手机号
      code: "",//验证码
      smsType: '23',//验证类型
      mobileAreaCode: ''//国际区号
    })
    /**
    * 电话验证参数-结束
    * /

   /**
    * 关闭弹框-开始
    */
    function handleCancel() {
      BindingEmailModelFlag.value = false;
      BindingEmailModelFlagNext.value = false;
      phoneData.code = '';
      phoneData.phone = '';
      emailData.email = '';
      emailData.code = '';
    }
    /**
     * 关闭弹框-结束
     */

    /**
     * 发送手机验证码-开始
     */
    const isSending = ref(false);
    const sendPhoneCode = async () => {
      if (isSending.value) {
        return;
      }
      // 没填电话号码
      if (phoneData.phone == '') {
        ElMessage({
          message: t('signUp.text20'),
          type: 'error',
        })
        return
      }
      sendphoneCodeFunc({ ret: 0 })
      //  try {
      //     var captcha = new TencentCaptcha('190327966', sendphoneCodeFunc, {'userLanguage':lang.value == 'cn'?'zh':'en','needFeedBack': false});
      //     captcha.show(); 
      // } catch (error) {
      //       loadErrorCallback();
      // }
    };

    // 发起请求
    let timer = null;
    const time = ref(60);
    async function sendphoneCodeFunc(result) {
      console.log("result", result)
      if (result.ret != 0) return;
      if (timer) {
        return;
      }
      isSending.value = true;
      sendMessage.value = t('signUp.text18');
      const params = {
        smsType: 23,
        phone: window.btoa(phoneData.phone),
        mobileAreaCode: phoneData.mobileAreaCode,
        ticket: result.ticket,
        randstr: result.randstr
      };
      const res = await apiService.GetByMobile(params);
      if (res.status === 1) {
        ElMessage({
          message: t('signUp.text19'),
          type: 'success',
        })
        sendMessage.value = `${time.value}S`;
        timer = setInterval(() => {
          sendMessage.value = `${time.value}S`;
          time.value -= 1;
          if (time.value <= 0) {
            isSending.value = false;
            clearInterval(timer);
            sendMessage.value = t('signUp.text17');
            time.value = 60;
            timer = null;
          }
        }, 1000);
      } else {
        ElMessage({
          message: res.message,
          type: 'error',
        })
        sendMessage.value = t('signUp.text16');
        isSending.value = false;
      }
    }
    /**
     * 发送手机验证码-结束
     */



    /**
     * 手机验证按钮提交条件-开始
     */
    const submitFlag = computed(() => {
      return phoneData.phone != "" &&
        phoneData.code != ""
    })
    /**
     * 手机验证按钮提交条件-结束
     */

    /**
     * 手机验证提交-开始
     */
    function sureEmailOK() {
      loading.value = true;
      const params = {
        smsType: emailData.smsType,
        code: emailData.code,
        account: window.btoa(emailData.email),
      };
      apiService.CheckVerifyCode(params).then((res) => {
        if (res.status == 1) {
          loading.value = false;
          BindingEmailModelFlag.value = false;
          BindingEmailModelFlagNext.value = true;
          clearInterval(timer);
          sendMessage.value = t('signUp.text16');
          time.value = 60;
          timer = null;
          isSending.value = false;
        } else {
          loading.value = false;
          isSending.value = false;
          ElMessage({
            message: res.message,
            type: 'error',
          });
        }
      });
    }
    /**
     * 手机验证提交-结束
     */


    /**
    * 邮箱验证参数-开始
    */
    const emailData = reactive({
      email: "",//邮箱号
      code: "",//验证码
      smsType: '20',//验证类型
    })
    /**
    * 邮箱验证参数-结束
    */

    /**
    * 邮箱验证按钮提交条件-开始
    */
    const emailSubmitFlag = computed(() => {
      return emailData.phone != "" &&
        emailData.code != ""
    })
    /**
     * 邮箱验证按钮提交条件-结束
     */

    /**
     * 邮箱发送验证码-开始
     */
    const sendEmailCode = async () => {
      console.log('sendCode');
      if (isSending.value) {
        return;
      }

      if (emailData.email == '') {
        ElMessage({
          message: t('signUp.text42'),
          type: 'error',
        })
        return
      }

      if (checkEmailPatern(emailData.email)) {
      } else {
        ElMessage({
          message: t('signUp.text43'),
          type: 'error',
        })
        return
      }
      await sendEmailCodeFunc();
    };

    // 检查邮箱
    function checkEmailPatern(value) {
      const cpVal = value.replace(/\s+/g, '');
      const myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,9}$/;
      return myreg.test(cpVal);
    }
    async function sendEmailCodeFunc() {
      if (timer) {
        return;
      }
      isSending.value = true;
      sendMessage.value = t('signUp.text18');
      let res;
      const params = {
        smsType: emailData.smsType,
        email: window.btoa(emailData.email),
      };
      res = await apiService.GetByEmail(params);
      if (res.status === 1) {
        sendMessage.value = `${time.value}S`;
        timer = setInterval(() => {
          sendMessage.value = `${time.value}S`;
          time.value -= 1;
          if (time.value <= 0) {
            isSending.value = false;
            clearInterval(timer);
            sendMessage.value = t('signUp.text17');
            time.value = 60;
            timer = null;
          }
        }, 1000);
      } else {
        ElMessage({
          message: res.message,
          type: 'error',
        })
        sendMessage.value = t('signUp.text16');
        isSending.value = false;
      }
    }
    /**
     * 邮箱发送验证码-结束
     */



    /**
     * 手机绑定-开始
     */
    function bindPhone() {
      const params = {
        phone: window.btoa(phoneData.phone),
        code: phoneData.code,
        mobileAreaCode:phoneData.mobileAreaCode,
        checkCode: true
      };
      loading.value = true;
      apiService.BindPhone(params).then((res) => {
        if (res.status == 1) {
          ElMessage({
            message: t('components.text19'),
            type: 'success',
          });
          store.dispatch('getUserInfo');
          handleCancel();
        } else {
          ElMessage({
            message: res.message,
            type: 'error',
          })
        }
        loading.value = false;
      });
    }
    /**
     * 邮箱绑定-结束
     */

    /**
     * 关闭弹框-开始
     */
    function beforeClose() {
      phoneData.code = '';
      phoneData.phone = '';
      emailData.email = '';
      emailData.code = '';
    }
    /**
     * 关闭弹框-结束
     */
    return {
      BindingEmailModelFlagNext,
      BindingEmailModelFlag,
      phoneData,
      emailData,
      sendMessage,
      sendPhoneCode,
      timer,
      submitFlag,
      loading,
      sendEmailCode,
      emailSubmitFlag,
      codeBlur,
      phoneBlur,
      beforeClose,
      sureEmailOK,
      bindPhone,
      mobileAreaCodeChange
    }
  }
}
</script>
<style lang="less" scoped>
.BindPhone {
  .input-row {
    margin: 0 auto;
    background: white;
    margin-bottom: 20px;
    border-radius: 4px;
    height: 40px;
    /*no*/
    position: relative;
    width: 100%;
    border: 1px solid @border-color-base;

    .value {
      /*no*/
      width: 100%;
      /*no*/
    }

    .password-icon {
      position: absolute;
      right: 16px;
      /*no*/
      top: 10px;
      /*no*/
      cursor: pointer;
    }

    .send {
      position: absolute;
      right: 10px;
      /*no*/
      top: 4px;
      /*no*/
    }

    input {
      height: 38px;
      /*no*/
      outline: none;
      padding-left: 16px;
      /*no*/
      width: 100%;
    }

    .value_code {
      padding-left: 10px;
      /*no*/
    }
  }

  .modify_the_email_2 {
    .input-row {
      input {
        padding-left: 8px;
        /*no*/
        width: 100%;
        /*no*/
      }
    }
  }
}
</style>
<style lang="less">
.BindPhone {

  .input,
  .el-button {
    height: 32px;
    /*no*/
    line-height: 32px;
    /*no*/
    font-size: 14px;
    /*no*/
  }
}
</style>